import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import '../../assets/css/common.css';
import Header from './Header';
import Sidebar from './Sidebar';

const AccountLayout = () => {
  const accountItems = [
      { to: '/account', label: '회원정보관리' },
      { to: '/account/secession', label: '탈퇴회원' },
      { to: '/account/fingerprint', label: '지문관리' },
    ];

  return (
    <div className="wrap">
      <Header />
      <div className="section_area">
        <Sidebar items={accountItems}/>
        <div className="section_wrap">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AccountLayout;
